export default "__VITE_ASSET__e0c855f0__"